export const DATE_FORMATS = {
  DAY_MONTH_YEAR_TIME: "DD/MM/YYYY HH:mm",
  DAY_MONTH_YEAR: "DD/MM/YYYY",
  YEAR_MONTH_DAY_TIME: "YYYY-MM-DD HH:mm:ss",
} as const;
